import { Display3 } from '@sainsburys-tech/luna-typography'
import { Container } from '@sainsburys-tech/luna-grid'
import { ITitle } from '../../../../../types/ComponentTypes/Components'

function TitleComponent({ value }: ITitle) {
  return (
    <Container>
      <Display3>{value}</Display3>
    </Container>
  )
}

export default TitleComponent
